module.exports = __webpack_public_path__ + "img/302b13d.svg";